import {getRandomInteger} from '../../../utils/numerals/getRandomInteger';
import {spaceNumber} from '../../../utils/numerals/spaceNumber';
import {trigger} from '../../../utils/events/trigger';

export const initScrollToFinishing = ( apartmentCard ) => {
	const linksToFinishing = apartmentCard.querySelectorAll( 'a.to-finishing' );

	if ( !linksToFinishing.length )
	{
		return;
	}

	const basicPrice = apartmentCard.querySelector( 'li.basic-price' );
	const salePrice = apartmentCard.querySelector( 'li.price' );
	const initDiscount = salePrice.dataset.discount ? salePrice.dataset.discount.replace( / /gu, '' ).replace( 'Скидка', '' ).replace( '₽', '' ) : 0;
	
	const finishingSlider = document.querySelector( 'section.cds2-slider-with-tooltips.finishing' );
	
	Array.from( apartmentCard.querySelectorAll( 'input[name="finishing"]' ) ).forEach( ( it ) => {
		let changePriceInverval = null;
		
		it.addEventListener( 'change', () => {
			clearInterval( changePriceInverval );
			
			if ( basicPrice )
			{
				basicPrice.innerHTML = it.dataset.base;

				const priceInCalc = document.querySelector( 'section.cds2-mortgage-calculator input[name="price"][readonly]' );

				if ( priceInCalc )
				{
					priceInCalc.value = it.dataset.sale.replace( 'от', '' );
					document.querySelector( 'section.cds2-mortgage-calculator div[data-type="install_payment"]' ).dataset.fromValue = it.dataset.sale.replace( / /gu, '' ).replace( 'от', '' ).replace( '₽', '' );
					trigger( priceInCalc, 'change' );
				}

				const newPrice = it.dataset.sale.replace( / /gu, '' ).replace( 'от', '' ).replace( '₽', '' );
				let oldPrice = salePrice.innerHTML.replace( / /gu, '' ).replace( 'от', '' ).replace( '₽', '' );
				const diff = Math.abs( oldPrice - newPrice );

				if ( diff )
				{
					const direction = ( oldPrice - newPrice ) / diff;

					changePriceInverval = setInterval( () => {
						const randomInteger = getRandomInteger( 5000, 25000 );

						oldPrice -= randomInteger * direction;

						if ( ( oldPrice > newPrice && direction < 0 ) || ( oldPrice < newPrice && direction > 0 ) )
						{
							oldPrice = newPrice;
							clearInterval( changePriceInverval );
						}

						salePrice.innerHTML = `${spaceNumber( oldPrice )} ₽`;
					}, 10 );
				}
			}
			else
			{
				const discount = initDiscount - it.dataset.price.replace( / /gu, '' ).replace( '₽', '' );
				
				salePrice.dataset.discount = `Скидка ${spaceNumber( discount )} ₽`;
			}

			Array.from( document.querySelectorAll( 'input[name="finishing_name"]' ) ).forEach( ( input ) => {
				input.value = it.dataset.title;
			} );
			
			/* В слайдере с тултипами (finishingSlider) переключаются табы при выборе отделки */
			if ( finishingSlider )
			{
				const newFinishingValue = it.getAttribute( 'data-finishing' );
				
				if ( newFinishingValue )
				{
					const tab = finishingSlider.querySelector( `div.tabs li[data-tab-value="${newFinishingValue}"` );
					
					if ( tab )
					{
						tab.click();
					}
				}
			}
		} );
	} );

	const buttonToPhotos = apartmentCard.querySelector( 'li.has-photos button.photos' );
	const apartmentPhotos = document.querySelector( 'section.cds2-slider-with-tooltips.apartment-photos' );

	if ( apartmentPhotos )
	{
		buttonToPhotos.addEventListener( 'click', ( evt ) => {
			evt.preventDefault();
	
			const requestedElement = apartmentPhotos;

			requestedElement.scrollIntoView( { behavior: 'smooth' } );
		} );
	}
	
	if ( !finishingSlider )
	{
		Array.from( linksToFinishing ).forEach( ( it ) => {
			it.remove();
		} );

		return;
	}

	document.addEventListener( 'click', ( evt ) => {
		if ( !evt.target.classList.contains( 'to-finishing' ) )
		{
			return;
		}

		evt.preventDefault();

		const requestedElement = finishingSlider;

		requestedElement.scrollIntoView( { behavior: 'smooth' } );
	} );
};
